'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dCert$002dChain$002dRequest from "./presto.-Agent-View$-Local-Pje-Office-Cert-Chain-Request.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$LocalPjeOfficeCertChainRequest$() {
}
export { $c_Lpresto_AgentView$LocalPjeOfficeCertChainRequest$ as $c_Lpresto_AgentView$LocalPjeOfficeCertChainRequest$ };
$p = $c_Lpresto_AgentView$LocalPjeOfficeCertChainRequest$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$LocalPjeOfficeCertChainRequest$;
/** @constructor */
function $h_Lpresto_AgentView$LocalPjeOfficeCertChainRequest$() {
}
export { $h_Lpresto_AgentView$LocalPjeOfficeCertChainRequest$ as $h_Lpresto_AgentView$LocalPjeOfficeCertChainRequest$ };
$h_Lpresto_AgentView$LocalPjeOfficeCertChainRequest$.prototype = $p;
$p.l = (function() {
  return "LocalPjeOfficeCertChainRequest";
});
$p.cFU = (function(x$0) {
  return new $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dCert$002dChain$002dRequest.$c_Lpresto_AgentView$LocalPjeOfficeCertChainRequest(x$0.j(0));
});
var $d_Lpresto_AgentView$LocalPjeOfficeCertChainRequest$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$LocalPjeOfficeCertChainRequest$, "presto.AgentView$LocalPjeOfficeCertChainRequest$", ({
  Eh: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_AgentView$LocalPjeOfficeCertChainRequest$ as $d_Lpresto_AgentView$LocalPjeOfficeCertChainRequest$ };
var $n_Lpresto_AgentView$LocalPjeOfficeCertChainRequest$;
function $m_Lpresto_AgentView$LocalPjeOfficeCertChainRequest$() {
  if ((!$n_Lpresto_AgentView$LocalPjeOfficeCertChainRequest$)) {
    $n_Lpresto_AgentView$LocalPjeOfficeCertChainRequest$ = new $c_Lpresto_AgentView$LocalPjeOfficeCertChainRequest$();
  }
  return $n_Lpresto_AgentView$LocalPjeOfficeCertChainRequest$;
}
export { $m_Lpresto_AgentView$LocalPjeOfficeCertChainRequest$ as $m_Lpresto_AgentView$LocalPjeOfficeCertChainRequest$ };
//# sourceMappingURL=presto.-Agent-View$-Local-Pje-Office-Cert-Chain-Request$.js.map
